import { render, staticRenderFns } from "./ExhibitionPartnerProductList.vue?vue&type=template&id=1a587dfb&scoped=true"
import script from "./ExhibitionPartnerProductList.vue?vue&type=script&lang=js"
export * from "./ExhibitionPartnerProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a587dfb",
  null
  
)

export default component.exports